import fetch from '@adc/fetch'
import { utils } from '@adc/ui-morpheus'
import seek from '@adc/seek'

/**
 * Characters that are not indexed by OpenSearch's standard analyzer
 * and should be removed from search values to avoid empty term matches.
 * The standard analyzer treats these as word separators, so they don't
 * exist as searchable tokens in the index.
 */
const CHARS_TO_STRIP_FROM_SEARCH = ['&', ',']

const stripNonIndexedChars = value => {
  if (typeof value !== 'string') return value
  return CHARS_TO_STRIP_FROM_SEARCH.reduce(
    (result, char) => result.replace(new RegExp(`\\${char}`, 'g'), ' '),
    value
  )
}

const processFilterValues = filterBy => {
  if (!filterBy) return filterBy
  return filterBy.map(clause => ({
    ...clause,
    values: clause.values?.map(stripNonIndexedChars),
  }))
}

const seekThroughGraph = async (req, fetchOptions, type, operationName) => {
  const { offset, size, sortBy, filterBy, fields } = fetchOptions
  const processedFilterBy = processFilterValues(filterBy)
  const query = utils.elasticSearch.buildQuery(processedFilterBy)
  let q = seek.for(type).size(size).offset(offset).fields(fields)
  // Naming the operation makes the call identifiable in the Network tab / logs;
  // omitted callers fall back to @adc/seek's auto-generated default name.
  if (operationName) q = q.operationName(operationName)

  // Hacking out the seek client to get this working, and to take advantage of filter logic we alrady have in toolkit
  q._sort = sortBy
  q._query = {
    toObject: () => query,
  }

  // Use q.toQuery(false) when you don't need to explicitly define the fields in the dsl
  // Using default true value here to reduce the seek service load as we don't want to call payload data
  return fetch
    .forAuctionGraph(q.toParameterizedQuery())
    .then(res => res.body.data.seek)
}

export default seekThroughGraph
